<template>
  <div class="menuFrame">
    <loading :active.sync="isLoading"></loading>

    <!-- track -->
    <div id="track">
      <div class="d-flex justify-content-between">
        <div>
          <a
            class="linkstyle"
            href="https://www.chanchao.com.tw/ExhibitorServiceTW/en"
            >Exhibition List</a
          >
          <span>/</span> <em name="Exhibition">{{ ExhibitionName }}</em
          ><span>/</span><span name="homeDirectoryTitleEn"></span>
        </div>
        <div>
          <span class="bold">Account :</span>
          <span> {{ UserId }}</span>
        </div>
      </div>
    </div>
    <!-- track end -->
    <!-- article -->

    <div class="MbDevice">
      <div class="homeLeft mt-5">
        <div class="UserAccount ml-1">
          <span class="bold">Account :</span>
          <span> {{ UserId }}</span>
        </div>
        <hr />
        <p class="my-3">&nbsp;</p>

        <div class="expoLogo">
          <div class="imgCorp squareThumb">
            <img :src="ExhLogo" width="100%" />
          </div>
        </div>
        <div class="expoInfo">
          <p class="bold" name="Exhibition">{{ ExhibitionName }}</p>
          <p>{{ Exhdate }}</p>
          <p>{{ eExhVenue }}</p>
        </div>

        <p class="clear"></p>
      </div>
    </div>

    <div class="articleEn">
      <div class="contentBox">
        <h1><span name="homeDirectoryTitleEn"></span></h1>
        <p class="my-3">&nbsp;</p>

        <div v-if="openDirectory == '0'" class="mx-md-4">
          <div class="alert" style="font-size: 15px">
            Show directory function is unavailable.
          </div>
        </div>

        <div v-else-if="openDirectory == '1'" class="mx-md-4">
          <div class="alert">
            <div class="HasDirectory">
              <p>
                Please complete your show directory before<span class="red">
                  {{ directoryListDeadline }} </span
                >. We will publish your information in the exhibition show
                directory. Failure to complete will not be published. If you
                need to modify company name, telephone, fax,<a
                  href="//www.chanchao.com.tw/en/contact.asp"
                  target="_blank"
                >
                  please contact the organizer</a
                >.
              </p>
            </div>
            <p class="mt-1">
              The following content (Company Name, Website and Company/Product
              Intro.) will be shown on the official website > Exhibitor List.
            </p>
          </div>
          <p class="my-3">&nbsp;</p>

          <div v-if="!dateExpired">
            <table class="table w-100 mt-5 table-bordered">
              <thead class="thead-dark">
                <tr>
                  <th class="text-center h5">
                    <span name="homeDirectoryTitleEn"></span>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <form
                      name="thisform"
                      id="form"
                      class="mx-3"
                      @submit.prevent="submitform"
                    >
                      <input type="hidden" name="RegNo" />
                      <!-- Historical data -->
                      <div id="HistoryDir" v-if="analHistory" class="mt-4">
                        You have historical show directory data. Please click
                        <button
                          class="ml-2 mb-1 btn btn-primary px-4"
                          @click.prevent="OpenCopyModal"
                        >
                          Import Previous Directory Data
                        </button>
                        <p class="red mt-2" v-if="alertSubmit">
                          *Please confirm the imported historical data is
                          correct, and press the submit button to complete the
                          upload.
                        </p>
                      </div>

                      <h3 name="Directory_ComName" class="mt-4">
                        {{ Directory_ComName }}
                      </h3>
                      <input type="hidden" name="ComName" />
                      <p name="Directory_eComName">{{ Directory_eComName }}</p>
                      <input type="hidden" name="eComName" />
                      <p class="divider"></p>

                      <div class="my-2">
                        <p class="formTitle">Tel</p>
                        <p>{{ RegTel }}</p>
                        <p v-if="RegFax" class="formTitle mt-2">Fax</p>
                        <p>{{ RegFax }}</p>
                      </div>

                      <p class="my-3">&nbsp;</p>

                      <p class="formTitle">
                        Postcode <span class="red">*</span>
                      </p>
                      <input
                        type="text"
                        name="ComPostalcode"
                        v-model="directoryList.ComPostalcode"
                        class="codeText textStyle"
                        maxlength="10"
                        required
                      />
                      <p class="my-3">&nbsp;</p>

                      <p class="formTitle">
                        Address <span class="red">*</span>
                      </p>

                      <div class="langTip">
                        <input
                          type="text"
                          name="eComAddress"
                          v-model="directoryList.eComAddress"
                          class="maxText textStyle"
                          maxlength="200"
                          required
                        />
                        <span>EN</span>
                      </div>
                      <div v-if="!isOverseas">
                        <p class="divider"></p>
                        <div class="langTip">
                          <input
                            type="text"
                            name="ComAddress"
                            v-model="directoryList.ComAddress"
                            class="maxText textStyle"
                            maxlength="200"
                            required
                          />
                          <span>中</span>
                        </div>
                      </div>

                      <p class="my-3">&nbsp;</p>
                      <div class="left">
                        <p class="formTitle">
                          Email <span class="red">*</span>
                        </p>
                        <input
                          type="text"
                          name="ComEmail"
                          v-model="directoryList.ComEmail"
                          class="maxText textStyle"
                          maxlength="100"
                          required
                        />

                        <p class="grayBG mt-2">
                          If you are submitting multiple emails, please add
                          semicolon(;) to separate each email, ex.
                          chanchao@gmail.com;exhibitorTW@gmail.com
                        </p>
                        {{ anaText }}
                        <div v-if="alertMail">
                          <span style="font-size: 13px; color: #e42212"
                            >Email contains special character.</span
                          >
                        </div>
                      </div>

                      <div class="right">
                        <p class="formTitle">Website</p>
                        <input
                          type="text"
                          name="ComWebsite"
                          v-model="directoryList.ComWebsite"
                          class="maxText textStyle"
                          maxlength="100"
                        />
                        <p class="grayBG mt-2">
                          The website provided here must contain http or https,
                          or the link may not be working.
                        </p>
                      </div>
                      <p class="clear">&nbsp;</p>
                      <p class="my-3">&nbsp;</p>

                      <p class="formTitle">
                        Company/Product Intro. (EN) <span class="red">*</span>
                      </p>
                      <div>
                        <textarea
                          name="eProduct"
                          rows="8"
                          class="maxText textStyle"
                          v-model="directoryList.eProduct"
                          @input="ecountNums"
                          required
                          placeholder="English"
                        ></textarea>
                        <p class="divider"></p>

                        <p class="blueBG" v-if="enWdNum">
                          Max. {{ eDirectoryProductLimit }} characters<span
                            v-if="eExtraWdNum !== 0"
                          >
                            <span
                              >, and {{ eExtraWdNum }} characters remaining
                            </span>
                          </span>
                        </p>
                        <p class="redBG" v-else>
                          *Max. {{ eDirectoryProductLimit }} characters,
                          Exceeded {{ eExtraWdNum }} characters
                        </p>
                      </div>
                      <p class="my-3">&nbsp;</p>

                      <div v-if="!isOverseas">
                        <p class="formTitle">
                          Company/Product Intro. (CN) <span class="red">*</span>
                        </p>
                        <div>
                          <textarea
                            name="Product"
                            rows="8"
                            class="maxText textStyle"
                            v-model="directoryList.Product"
                            @input="countNums"
                            required
                            placeholder="中文"
                          ></textarea>
                          <p class="divider"></p>

                          <p class="blueBG" v-if="cnWdNum">
                            Max. {{ DirectoryProductLimit }} characters<span
                              v-if="ExtraWdNum !== 0"
                            >
                              <span
                                >, and {{ ExtraWdNum }} characters remaining
                              </span>
                            </span>
                          </p>
                          <p class="redBG" v-else>
                            *Max. {{ DirectoryProductLimit }} characters,
                            Exceeded {{ ExtraWdNum }} characters
                          </p>
                        </div>
                      </div>
                      <p class="my-3">&nbsp;</p>

                      <div class="text-center mb-3">
                        <input
                          type="submit"
                          value="Submit"
                          class="btn btn-primary py-2 px-4"
                        />
                      </div>
                    </form>
                  </td>
                </tr>
              </tbody>
            </table>

            <div class="mt-5" v-if="isOverseas">
              <table class="table table-bordered w-100">
                <thead class="thead-light">
                  <tr>
                    <th colspan="3" class="text-center bg-dark text-white h5">
                      Agency Information
                    </th>
                  </tr>
                  <tr v-if="DirectoryOrgList.length > 0">
                    <th class="text-center" style="width: 5%">No.</th>
                    <th class="text-center" style="width: 30%">Content</th>
                    <th class="text-center" style="width: 5%">Manage</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, index) in DirectoryOrgList" :key="item.id">
                    <td class="text-center align-middle">{{ index + 1 }}.</td>
                    <td>
                      <div class="row">
                        <div class="col-md-6">
                          <div class="mb-2">
                            <span class="bold">Nature:</span>
                            {{ item.Checked }}
                          </div>
                          <div class="mb-2">
                            <span class="bold">Company:</span>
                            {{ item.Name }}
                          </div>
                          <div class="mb-2">
                            <span class="bold">Country:</span>
                            {{ item.Country }}
                          </div>
                          <div class="mb-2">
                            <span class="bold">Address:</span>
                            {{ item.Address }}
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="mb-2">
                            <span class="bold">Tel:</span>
                            {{ item.Tel }}
                          </div>
                          <div class="mb-2">
                            <span class="bold">ZIP / Postal Code:</span>
                            {{ item.Postalcode }}
                          </div>
                          <div class="mb-2">
                            <span class="bold">Email:</span>
                            {{ item.Email }}
                          </div>
                        </div>
                      </div>
                    </td>

                    <td class="text-center align-middle">
                      <button
                        type="button"
                        class="btn btn-secondary"
                        @click.prevent="deleteDirectoryOrg(item.id)"
                      >
                        Delete
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>

              <div class="text-center mt-3">
                <div
                  class="btn btn-primary mt-3 py-2 px-4"
                  @click="OpenAgencyModal"
                  v-if="analLogin"
                >
                  Add Agency
                </div>

                <div v-else>
                  <div class="btn btn-primary mt-3 py-2 px-4 disabled">
                    Add Agency
                  </div>
                  <div class="mt-2 red">
                    *Please complete the directory entry process before adding
                    agency information.
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- expired -->
          <div v-if="dateExpired">
            <table class="table w-100 mt-5 table-bordered">
              <thead class="thead-dark">
                <tr>
                  <th class="text-center h5">
                    <span name="homeDirectoryTitleEn"></span>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <p class="formTitle mb-2">Company Name</p>
                    <p>{{ directoryList.Directory_ComName }}</p>
                    <p>{{ directoryList.Directory_eComName }}</p>
                    <p class="my-3">&nbsp;</p>

                    <div>
                      <p class="formTitle">Tel</p>
                      <p>{{ directoryList.ComTel }}</p>
                    </div>
                    <p class="my-3">&nbsp;</p>

                    <div>
                      <p v-if="directoryList.ComFax" class="formTitle mt-2">
                        Fax
                      </p>
                      <p>{{ directoryList.ComFax }}</p>
                    </div>

                    <p class="my-3">&nbsp;</p>

                    <div>
                      <p class="formTitle">
                        Postcode <span class="red">*</span>
                      </p>
                      <p>{{ directoryList.ComPostalcode }}</p>
                    </div>

                    <p class="my-3">&nbsp;</p>
                    <div class="mb-2">
                      <p class="formTitle">
                        Address <span class="red">*</span>
                      </p>
                      <div class="langTip" v-if="!isOverseas">
                        {{ directoryList.ComAddress }}
                      </div>

                      <div class="langTip">
                        {{ directoryList.eComAddress }}
                      </div>
                    </div>

                    <p class="my-3">&nbsp;</p>
                    <div class="mb-2">
                      <div class="left">
                        <p class="formTitle">
                          Email <span class="red">*</span>
                        </p>
                        <ul v-for="item in directoryEmail" :key="item">
                          <li>{{ item }}</li>
                        </ul>
                      </div>
                      <div class="right">
                        <p class="formTitle">Website</p>
                        {{ directoryList.ComWebsite }}
                      </div>
                    </div>

                    <p class="clear">&nbsp;</p>
                    <p class="my-3">&nbsp;</p>

                    <div v-if="!isOverseas">
                      <p class="formTitle mt-2">
                        Company/Product Intro. (CN)
                        <span class="red">*</span>
                      </p>
                      <div>
                        {{ directoryList.Product }}
                      </div>
                    </div>
                    <p class="my-3">&nbsp;</p>
                    <p class="formTitle mt-2">
                      Company/Product Intro. (EN)
                      <span class="red">*</span>
                    </p>
                    <div>
                      {{ directoryList.eProduct }}
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>

            <div class="mt-5" v-if="isOverseas">
              <table class="table table-bordered w-100">
                <thead class="thead-light">
                  <tr>
                    <th colspan="3" class="text-center bg-dark text-white h5">
                      Agency Information
                    </th>
                  </tr>
                  <tr v-if="DirectoryOrgList.length > 0">
                    <th class="text-center" style="width: 5%">No.</th>
                    <th class="text-center" style="width: 30%">Content</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, index) in DirectoryOrgList" :key="item.id">
                    <td class="text-center align-middle">{{ index + 1 }}.</td>
                    <td>
                      <div class="row">
                        <div class="col-md-6">
                          <div class="mb-2">
                            <span class="bold">Nature:</span>
                            {{ item.Checked }}
                          </div>
                          <div class="mb-2">
                            <span class="bold">Company:</span>
                            {{ item.Name }}
                          </div>
                          <div class="mb-2">
                            <span class="bold">Country:</span>
                            {{ item.Country }}
                          </div>
                          <div class="mb-2">
                            <span class="bold">Address:</span>
                            {{ item.Address }}
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="mb-2">
                            <span class="bold">Tel:</span>
                            {{ item.Tel }}
                          </div>
                          <div class="mb-2">
                            <span class="bold">ZIP / Postal Code:</span>
                            {{ item.Postalcode }}
                          </div>
                          <div class="mb-2">
                            <span class="bold">Email:</span>
                            {{ item.Email }}
                          </div>
                        </div>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal -->
    <div
      class="modal fade"
      id="AgencyModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="ModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <div>
              <div class="modal-title h3" id="ModalLabel">
                <div class="d-flex align-items-center">
                  <img
                    src="@/assets/images/commission.png"
                    width="36px"
                    alt=""
                  />
                  <div class="ml-2">Add Agency</div>
                </div>
              </div>
            </div>

            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>

          <form @submit.prevent="submitAgency">
            <div class="modal-body">
              <div class="alert alert-light text-dark px-2" role="alert">
                <p>
                  <i class="fas fa-exclamation-circle"> </i> Maximum of 10
                  agency information allowed
                </p>
              </div>
              <p class="my-3">&nbsp;</p>

              <p class="formTitle">Company Nature <span class="red">*</span></p>
              <div class="langTip mb-3" style="width: 180px">
                <select
                  class="form-control text-dark"
                  v-model="optionNature"
                  required
                >
                  <option value="">-- Select --</option>
                  <option
                    v-for="(item, index) in AgencyNatureList"
                    :key="index"
                    :value="item.NatureName"
                  >
                    {{ item.NatureName }}
                  </option>
                </select>
              </div>

              <p class="formTitle">Company Name <span class="red">*</span></p>
              <div class="langTip mb-3">
                <input
                  type="text"
                  class="maxText textStyle"
                  required
                  maxlength="200"
                  v-model="eCom_Name"
                  @input="(e) => filterField('eCom_Name', e)"
                  @compositionstart="isComposing = true"
                  @compositionend="(e) => handleCompositionEnd('eCom_Name', e)"
                />
                <span>EN</span>
              </div>

              <p class="formTitle">Address <span class="red">*</span></p>
              <div class="langTip mb-3">
                <input
                  type="text"
                  class="maxText textStyle"
                  required
                  maxlength="400"
                  v-model="eCom_Address"
                  @input="(e) => filterField('eCom_Address', e)"
                  @compositionstart="isComposing = true"
                  @compositionend="
                    (e) => handleCompositionEnd('eCom_Address', e)
                  "
                />
                <span>EN</span>
              </div>

              <p class="formTitle">Country <span class="red">*</span></p>
              <div class="langTip mb-3" style="width: 180px">
                <select
                  class="form-control text-dark"
                  v-model="optionCountry"
                  required
                >
                  <option value="">-- Select --</option>
                  <optgroup label="Common Countries">
                    <option
                      v-for="item in CountryListCommon"
                      :key="item.Country_Code"
                      :value="item.Country_Code"
                    >
                      {{ item.eCountry }} {{ item.Country }}
                    </option>
                  </optgroup>

                  <optgroup label="Other Countries">
                    <option
                      v-for="item in CountryListOther"
                      :key="item.Country_Code"
                      :value="item.Country_Code"
                    >
                      {{ item.eCountry }} {{ item.Country }}
                    </option>
                  </optgroup>
                </select>
              </div>

              <p class="formTitle">
                ZIP / Postal Code: <span class="red">*</span>
              </p>
              <div class="langTip mb-3" style="width: 180px">
                <input
                  type="text"
                  class="maxText form-control"
                  inputmode="numeric"
                  required
                  maxlength="10"
                  v-model="Com_Postalcode"
                />
              </div>

              <p class="formTitle">Tel: <span class="red">*</span></p>
              <div class="langTip mb-3" style="width: 80%; text-align: left">
                <div class="row">
                  <div class="col">
                    <input
                      type="tel"
                      pattern="[0-9]*"
                      class="form-control"
                      maxlength="5"
                      placeholder="Country Code"
                      v-model="Tel1"
                      required
                    />
                  </div>
                  <div>-</div>
                  <div class="col">
                    <input
                      type="tel"
                      class="form-control"
                      pattern="[0-9]*"
                      maxlength="5"
                      placeholder="Area Code"
                      v-model="Tel2"
                      required
                    />
                  </div>
                  <div>-</div>
                  <div class="col">
                    <input
                      type="tel"
                      pattern="[0-9]*"
                      class="form-control"
                      maxlength="25"
                      placeholder="Number"
                      v-model="Tel3"
                      required
                    />
                  </div>
                </div>
              </div>

              <p class="formTitle">E-mail: <span class="red">*</span></p>
              <div class="langTip mb-3" style="width: 80%">
                <input
                  type="email"
                  class="maxText form-control"
                  required
                  maxlength="100"
                  v-model="Com_Email"
                />
              </div>
            </div>

            <div class="modal-footer">
              <div class="PcDevice">
                <button
                  type="submit"
                  id="cropImageBtn"
                  class="btn btn-primary btn-lg mr-2"
                >
                  Submit
                </button>
                <button
                  type="button"
                  class="btn btn-lg btn-secondary"
                  data-dismiss="modal"
                >
                  Close
                </button>
              </div>
              <div class="MbDevice">
                <button
                  type="submit"
                  id="cropImageBtn"
                  class="btn btn-primary mr-2"
                >
                  Submit
                </button>
                <button
                  type="button"
                  class="btn btn-secondary"
                  data-dismiss="modal"
                >
                  Close
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>

    <div
      class="modal fade"
      id="CopyModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="ModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <div>
              <div class="modal-title h3" id="ModalLabel">
                <div class="d-flex align-items-center">
                  <img
                    src="@/assets/images/open-folder2.png"
                    width="36px"
                    alt=""
                  />
                  <div class="ml-2">Previous Show Directory List</div>
                </div>
              </div>
            </div>

            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>

          <div class="modal-body">
            <div class="alert alert-light text-dark px-2" role="alert">
              <p>
                <i class="fas fa-exclamation-circle"> </i>
                This list shows the exhibitions you participated in within the
                last two years.
              </p>
            </div>
            <p class="my-3">&nbsp;</p>

            <ul
              v-for="(item, index) in HisDirectoryList"
              :key="index"
              class="mx-5 my-3"
            >
              <li>
                <div class="row justify-content-between align-items-center">
                  <div class="col-md-9 text-md-left text-center text-md-left">
                    <div class="row align-items-center">
                      <div class="col-md-4 text-center text-md-left">
                        <img
                          :src="`//www.ccie.com.tw/exhibition/images/exlogo/${item.Logo}`"
                          class="img-fluid mb-2 mb-md-0 px-5 px-md-0"
                        />
                      </div>
                      <div class="col-md-8 text-center text-md-left">
                        <p
                          class="bold mb-1 mb-2 mb-md-0"
                          style="font-size: 17px"
                        >
                          {{ item.eExhibition }}
                        </p>
                        <span>
                          <p class="gray">
                            {{ item.ExhBegin }} ~ {{ item.ExhEnd }}
                          </p>
                          <p class="gray">{{ item.eExhVenue }}</p>
                          <p class="divider">&nbsp;</p>
                          <p>{{ item.Directory_eComName }}</p>
                          <p>Exhibition Area: {{ item.eExhibArea }}</p>
                          <p>
                            Booth No.:
                            <span v-if="item.BoothNo == 'N/A'"> - </span>
                            <span v-else> {{ item.BoothNo }} </span>
                          </p>
                        </span>
                      </div>
                    </div>
                  </div>

                  <div class="col-md-3 text-right PcDevice">
                    <div
                      class="btn btn-lg btn-primary py-1"
                      @click.prevent="ShowDirectoryInfo(item.DirectoryId)"
                    >
                      Preview
                    </div>
                  </div>

                  <div class="col-md-3 text-center MbDevice mt-3">
                    <div
                      class="btn btn-primary"
                      @click.prevent="ShowDirectoryInfo(item.DirectoryId)"
                    >
                      Preview
                    </div>
                  </div>
                </div>
              </li>
              <hr />
            </ul>
          </div>

          <div class="modal-footer">
            <div class="text-center">
              <div class="PcDevice">
                <button
                  type="button"
                  class="btn btn-lg btn-secondary"
                  data-dismiss="modal"
                >
                  Close
                </button>
              </div>
              <div class="MbDevice">
                <button
                  type="button"
                  class="btn btn-secondary"
                  data-dismiss="modal"
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      class="modal fade"
      id="ShowDirectoryInfoModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="ModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <div>
              <div class="modal-title h3" id="ModalLabel">
                <i class="fas fa-eye mr-1"></i> Previous Show Directory Preview
              </div>
            </div>

            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>

          <div class="modal-body">
            <div class="bold mt-2 mb-1" style="font-size: 18px">
              {{ DirectoryInfo.eExhibition }}
            </div>
            <div>
              <p class="gray">
                {{ DirectoryInfo.ExhBegin }} ~ {{ DirectoryInfo.ExhEnd }}
              </p>
              <p class="gray mb-2">{{ DirectoryInfo.eExhVenue }}</p>
              <p>{{ DirectoryInfo.Directory_ComName }}</p>
              <p>{{ DirectoryInfo.Directory_eComName }}</p>

              <hr />

              <div class="mt-4">
                <p class="bold text-info">Postcode</p>
                <p style="word-break: break-all">
                  {{ DirectoryInfo.ComPostalcode || "-" }}
                </p>
              </div>
              <div class="mt-4">
                <p class="bold text-info">Address</p>
                <p>{{ DirectoryInfo.ComAddress || "-" }}</p>
                <p>{{ DirectoryInfo.eComAddress || "-" }}</p>
              </div>

              <div class="row mt-4">
                <div class="col-md-6">
                  <p class="bold text-info">Email</p>
                  <p style="word-break: break-all">
                    {{ DirectoryInfo.ComEmail || "-" }}
                  </p>
                </div>

                <div class="col-md-6">
                  <p class="bold text-info">Website</p>
                  <p style="word-break: break-all">
                    {{ DirectoryInfo.ComWebsite || "-" }}
                  </p>
                </div>
              </div>

              <div class="mt-4 bold text-info">Company/Product Intro. (CN)</div>
              <div class="mt-1" style="white-space: pre-line">
                {{ DirectoryInfo.Product || "-" }}
              </div>

              <div class="mt-4 bold text-info">Company/Product Intro. (EN)</div>
              <div class="mt-1" style="white-space: pre-line">
                {{ DirectoryInfo.eProduct || "-" }}
              </div>
            </div>
          </div>

          <div class="modal-footer">
            <div class="PcDevice">
              <button
                type="submit"
                id="cropImageBtn"
                class="btn btn-primary btn-lg mr-3"
                @click="getHistData(DirectoryInfo)"
              >
                Import
              </button>
              <button
                type="button"
                class="btn btn-lg btn-secondary"
                @click="BackList"
              >
                Back to List
              </button>
            </div>
            <div class="MbDevice">
              <button
                type="submit"
                id="cropImageBtn"
                class="btn btn-primary mr-2"
                @click="getHistData(DirectoryInfo)"
              >
                Import
              </button>
              <button type="button" class="btn btn-secondary" @click="BackList">
                Back to List
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import axios from "axios";

export default {
  metaInfo() {
    return {
      title: `Directory Entry - Chan Chao Exhibitor's Online Service System`,
    };
  },

  data() {
    return {
      UserId: "",
      CSRF_Token: "",
      RegNo: "",
      Currentdate: "",
      directoryList: [],
      directoryEmail: [],
      directoryHistoryList: [],
      HisDirectoryList: [],
      directoryListDeadline: "",
      DirectoryProductLimit: 0,
      eDirectoryProductLimit: 0,
      analLogin: false,
      analHistory: false,
      alertSubmit: false,
      dateExpired: false,

      Directory_ComName: "",
      Directory_eComName: "",
      RegFax: "",
      RegTel: "",

      ExtraWdNum: 0,
      eExtraWdNum: 0,

      alertMail: false,
      lang: "en",
      ExhLogo: "",
      ExhBegin: "",
      ExhEnd: "",
      ExhVenue: "",
      eExhVenue: "",
      Exhdate: "",

      openDirectory: "",

      cnWdNum: true,
      enWdNum: true,

      ExtrawordLeng: "",
      ExhibitionName: "",

      DirectoryHardcopy: false,
      DirectoryHardcopyNO: 1,
      DirectoryOrgList: [],

      AgencyNatureList: [
        { NatureName: "Agent" },
        { NatureName: "Principal" },
        { NatureName: "Branch" },
      ],

      optionNature: "",

      isLoading: false,

      eCom_Name: "",
      eCom_Address: "",
      Com_Postalcode: "",
      Tel1: "",
      Tel2: "",
      Tel3: "",
      Com_Email: "",
      optionCountry: "",
      CountryList: [],

      CountryListCommon: [],
      CountryListOther: [],
      DirectoryOrgTotal: 0,

      isOverseas: false,
      isComposing: false,
      DirectoryInfo: {},
    };
  },

  computed: {
    anaText() {
      const vm = this;

      if (vm.directoryList.ComEmail) {
        let pattern = new RegExp(
          "[`+~!#$^&*()=|{}':',\\[\\]<>/?~！#￥……&*（）——|{}【】‘；：”“'。，、？%]",
        );
        let analEmail = vm.directoryList.ComEmail.match(pattern);

        if (analEmail) {
          vm.alertMail = true;
        } else {
          vm.alertMail = false;
        }
      }
    },
  },

  methods: {
    filterField(field, e) {
      if (this.isComposing) return;
      const cleaned = e.target.value.replace(
        /[^a-zA-Z0-9 $*^!@#&()+%,./-]/g,
        "",
      );

      this[field] = cleaned;
      e.target.value = cleaned;
    },

    handleCompositionEnd(field, e) {
      this.isComposing = false;
      const cleaned = e.target.value.replace(
        /[^a-zA-Z0-9 $*^!@#&()+%,./-]/g,
        "",
      );
      this[field] = cleaned;
      e.target.value = cleaned;
    },

    submitAgency() {
      const vm = this;

      let url = `https://www.chanchao.com.tw/apiExhibitors/DirectoryOrg/Add/${vm.RegNo}`;

      const info = {
        Checked: vm.optionNature,
        Name: vm.eCom_Name,
        Address: vm.eCom_Address,
        CountryCode: vm.optionCountry,
        Postalcode: vm.Com_Postalcode,
        Tel1: vm.Tel1,
        Tel2: vm.Tel2,
        Tel3: vm.Tel3,
        Email: vm.Com_Email,
      };

      axios
        .post(url, info)
        .then((response) => {
          if (response.data.Code == 200) {
            location.reload();
          } else if (response.data.Code == 400) {
            alert("Up to 10 agencies can be added.");
          } else if (response.data.Code == 422) {
            alert("Invalid format.");
          } else if (response.data.Code == 500) {
            alert("The system is busy. Please try again later.");
          }
        })
        .catch((error) => {
          console.error("Error updating Fascia Name:", error);
        });
    },

    OpenAgencyModal() {
      if (this.DirectoryOrgTotal < 10) {
        $("#AgencyModal").modal("show");
      } else {
        alert("You can only add up to 10 agencies.");
      }
    },

    BackList() {
      $("#ShowDirectoryInfoModal").modal("hide");
      $("#CopyModal").modal("show");
    },

    OpenCopyModal() {
      $("#CopyModal").modal("show");
    },

    ShowDirectoryInfo(id) {
      $("#CopyModal").modal("hide");

      const vm = this;
      axios
        .get(`https://www.chanchao.com.tw/apiExhibitors/Directory/Detail/${id}`)
        .then((response) => {
          vm.DirectoryInfo = response.data.Data;
          $("#ShowDirectoryInfoModal").modal("show");
        });
    },

    deleteDirectoryOrg(id) {
      const vm = this;

      if (confirm("Delete this Agency?")) {
        const url = `/apiExhibitors/DirectoryOrg/Delete/${id}`;

        axios.post(url).then(function (response) {
          if (response.data.Code == 200) {
            location.reload();
          } else if (response.data.Code == 251) {
            alert("Other conditions or sending failed");
          } else if (response.data.Code == 252) {
            alert("CSRF validation failed");
          } else if (response.data.Code == 253) {
            alert("Deletion failed");
          } else if (response.data.Code == 500) {
            alert("The system is busy. Please try again later.");
          }
        });
      } else {
        return false;
      }
    },

    getHistData(DirectoryInfo) {
      const vm = this;

      if (vm.directoryList.ComEmail) {
        if (
          !confirm(
            "Some fields already contain content. Do you want to overwrite them?",
          )
        ) {
          return;
        }
      }

      vm.directoryList = { ...DirectoryInfo };

      $("#ShowDirectoryInfoModal").modal("hide");
      $("#CopyModal").modal("hide");
      vm.alertSubmit = true;

      const updateLimit = (limit, currentList, type) => {
        const text = currentList || "";
        const diff = limit - text.length;

        if (type === "cn") {
          this.cnWdNum = diff >= 0;
          vm.ExtraWdNum = Math.abs(diff);
        } else {
          this.enWdNum = diff >= 0;
          vm.eExtraWdNum = Math.abs(diff);
        }
      };

      updateLimit(vm.DirectoryProductLimit, vm.directoryList.Product, "cn");
      updateLimit(vm.eDirectoryProductLimit, vm.directoryList.eProduct, "en");
    },

    submitform() {
      const vm = this;

      let pattern = new RegExp(
        "[`+~!#$^&*()=|{}':',\\[\\]<>/?~！#￥……&*（）——|{}【】‘；：”“'。，、？%]",
      );
      let analEmail = vm.directoryList.ComEmail.match(pattern);

      if (!analEmail) {
        vm.isLoading = true;

        if (vm.isOverseas) {
          let info = {
            CSRF: vm.CSRF_Token,
            RegNo: vm.RegNo,
            ComName: vm.Directory_ComName,
            eComName: vm.Directory_eComName,
            ComPostalCode: vm.directoryList.ComPostalcode,
            ComAddress: "",
            eComAddress: vm.directoryList.eComAddress,
            ComTel: vm.RegTel,
            ComFax: vm.RegFax,
            ComEmail: vm.directoryList.ComEmail,
            ComWebsite: vm.directoryList.ComWebsite,
            Product: "",
            eProduct: vm.directoryList.eProduct,
          };

          const url = `/apiExhibitors/Directory/${this.DirectoryHardcopyNO}`;
          axios.post(url, info).then(function (response) {
            if (response.data.Code == 200) {
              alert("You have completed the show directory.");
              vm.isLoading = false;
              document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/en/directory?no=${vm.RegNo}`;
            } else if (response.data.Code == 251 || response.data.Code == 500) {
              alert("System is busy, please try again later.");
              vm.isLoading = false;
            } else if (response.data.Code == 252) {
              document.location.href = `https://www.chanchao.com.tw/`;
            } else if (response.data.Code == 253) {
              alert("Company/Product description within 500 words.");
              vm.isLoading = false;
            } else if (response.data.Code == 254) {
              alert("The directory is closed.");
              vm.isLoading = false;
            } else if (response.data.Code == 255) {
              alert("Invalid email, please check again.");
              vm.isLoading = false;
            }
          });
        } else {
          let info2 = {
            CSRF: vm.CSRF_Token,
            RegNo: vm.RegNo,
            ComName: vm.Directory_ComName,
            eComName: vm.Directory_eComName,
            ComPostalCode: vm.directoryList.ComPostalcode,
            ComAddress: vm.directoryList.ComAddress,
            eComAddress: vm.directoryList.eComAddress,
            ComTel: vm.RegTel,
            ComFax: vm.RegFax,
            ComEmail: vm.directoryList.ComEmail,
            ComWebsite: vm.directoryList.ComWebsite,
            Product: vm.directoryList.Product,
            eProduct: vm.directoryList.eProduct,
          };

          const url = `/apiExhibitors/Directory/${this.DirectoryHardcopyNO}`;
          axios.post(url, info2).then(function (response) {
            if (response.data.Code == 200) {
              alert("You have completed the show directory.");
              vm.isLoading = false;
              document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/en/directory?no=${vm.RegNo}`;
            } else if (response.data.Code == 251 || response.data.Code == 500) {
              alert("System is busy, please try again later.");
              vm.isLoading = false;
            } else if (response.data.Code == 252) {
              document.location.href = `https://www.chanchao.com.tw/`;
            } else if (response.data.Code == 253) {
              alert("Company/Product description within 500 words.");
              vm.isLoading = false;
            } else if (response.data.Code == 254) {
              alert("The directory is closed.");
              vm.isLoading = false;
            } else if (response.data.Code == 255) {
              alert("Invalid email, please check again.");
              vm.isLoading = false;
            }
          });
        }
      } else {
        alert("Email contains special character, please check again.");
      }
    },

    countNums() {
      const vm = this;

      var txtVal = (this.directoryList.Product || "").len();
      var AnalVal = vm.DirectoryProductLimit - txtVal;
      if (AnalVal >= 0) {
        this.cnWdNum = true;
        this.ExtraWdNum = AnalVal;
      } else {
        this.cnWdNum = false;
        this.ExtraWdNum = Math.abs(AnalVal);
      }
    },

    ecountNums() {
      const vm = this;

      var etxtVal = (this.directoryList.eProduct || "").len();
      var eAnalVal = vm.eDirectoryProductLimit - etxtVal;

      if (eAnalVal >= 0) {
        this.enWdNum = true;
        this.eExtraWdNum = eAnalVal;
      } else {
        this.enWdNum = false;
        this.eExtraWdNum = Math.abs(eAnalVal);
      }
    },
  },

  created() {
    const vm = this;

    String.prototype.len = function () {
      return this.replace(/[^\x00-\xff]/g, "rr").length;
    };

    axios
      .get("https://www.chanchao.com.tw/apiExhibitors/CSRF_Token")
      .then((response) => {
        vm.CSRF_Token = response.data;
      });

    axios
      .get(`https://www.chanchao.com.tw/apiExhibitors/UserID`)
      .then((response) => {
        vm.UserId = response.data;
      });

    let currentUrl = location.href;
    vm.RegNo = currentUrl.split("no=")[1];

    let theDate = new Date();
    vm.Currentdate = `${theDate.getFullYear()}/${
      theDate.getMonth() + 1
    }/${theDate.getDate()}`;

    axios
      .get(`https://www.chanchao.com.tw/apiExhibitors/Directory/${vm.RegNo}`)
      .then((response) => {
        vm.Directory_ComName = response.data.Data.ComName;
        vm.Directory_eComName = response.data.Data.eComName;
        vm.RegFax = response.data.Data.ComFax;
        vm.RegTel = response.data.Data.ComTel;
      });

    axios
      .get(
        `https://www.chanchao.com.tw/apiExhibitors/Exhibition/${vm.RegNo}/?lang=${vm.lang}`,
      )
      .then((response) => {
        vm.directoryListDeadline = response.data.Data.DirectoryDeadline;
        vm.DirectoryProductLimit = response.data.Data.DirectoryProductLimit;
        vm.eDirectoryProductLimit = response.data.Data.eDirectoryProductLimit;
        vm.ExhLogo = `//www.ccie.com.tw/exhibition/images/exlogo/${response.data.Data.ExhLogo}`;
        vm.ExhBegin = response.data.Data.ExhBegin;
        vm.ExhEnd = response.data.Data.ExhEnd;
        vm.ExhVenue = response.data.Data.ExhVenue;
        vm.eExhVenue = response.data.Data.eExhVenue;
        vm.Exhdate = `${response.data.Data.ExhBegin} - ${response.data.Data.ExhEnd}`;
        vm.openDirectory = response.data.Data.DirectoryArchived;
        vm.ExhibitionName = response.data.Data.Exhibition;

        if (response.data.Data.ExpoLocation == "O") {
          vm.isOverseas = true;
        } else {
          vm.isOverseas = false;
        }

        vm.$nextTick(() => {
          if (response.data.Data.DirectoryHardcopy == 1) {
            vm.DirectoryHardcopy = false;
            vm.DirectoryHardcopyNO = 1;
            $('[name="directoryTitle"]').text("會刊登錄");
            $('[name="directoryTitleEn"]').text("Directory Entry");
            $('[name="profileTitleEn"]').text("Basic Information");
            $('[name="homeCompanyInfo"]').text("基本資料");
            $('[name="homeDirectoryTitle"]').text("會刊登錄");
            $('[name="homeDirectoryTitleEn"]').text("Directory Entry");
            $(".HasDirectory").addClass("show");
            $(".NoDirectory").addClass("hide");
            $("title").html(
              `Directory Entry - Chan Chao Exhibitor's Online Service System`,
            );
          } else {
            vm.DirectoryHardcopy = true;
            vm.DirectoryHardcopyNO = 0;
            $('[name="directoryTitle"]').text("廠商介紹");
            $('[name="directoryTitleEn"]').text("Exhibitor Profile");
            $('[name="profileTitleEn"]').text("Basic Information");
            $('[name="homeCompanyInfo"]').text("基本資料");
            $('[name="homeDirectoryTitle"]').text("廠商介紹");
            $('[name="homeDirectoryTitleEn"]').text("Exhibitor Profile");
            $(".HasDirectory").addClass("hide");
            $(".NoDirectory").addClass("show");
            $("title").html(
              `Exhibitor Profile - Chan Chao Exhibitor's Online Service System`,
            );
          }
        });

        if (!vm.DirectoryHardcopy) {
          if (
            Date.parse(vm.Currentdate).valueOf() >
            Date.parse(vm.directoryListDeadline).valueOf()
          ) {
            vm.dateExpired = true;
          } else {
            vm.dateExpired = false;
          }
        }

        axios
          .get(
            `https://www.chanchao.com.tw/apiExhibitors/Directory/${vm.RegNo}`,
          )
          .then((response) => {
            if (response.data.Data.eProduct || response.data.Data.Product) {
              vm.directoryList = response.data.Data;
              vm.directoryEmail = response.data.Data.ComEmail.split(";");

              let ExtraLeng =
                vm.DirectoryProductLimit - response.data.Data.Product.len();

              if (ExtraLeng >= 0) {
                this.cnWdNum = true;
                vm.ExtraWdNum = ExtraLeng;
              } else {
                this.cnWdNum = false;
                this.ExtraWdNum = Math.abs(ExtraLeng);
              }

              let eExtraLeng =
                vm.eDirectoryProductLimit - response.data.Data.eProduct.len();

              if (eExtraLeng >= 0) {
                this.enWdNum = true;
                vm.eExtraWdNum = eExtraLeng;
              } else {
                this.enWdNum = false;
                this.eExtraWdNum = Math.abs(eExtraLeng);
              }

              vm.analLogin = true;
            } else {
              vm.analLogin = false;
            }
          });

        axios
          .get(
            `https://www.chanchao.com.tw/apiExhibitors/Directory/List/${vm.RegNo}`,
          )
          .then((response) => {
            vm.HisDirectoryList = response.data.Data;

            if (vm.HisDirectoryList && vm.HisDirectoryList.length > 0) {
              vm.analHistory = true;
            } else {
              vm.analHistory = false;
            }
          });

        axios
          .get(`https://www.chanchao.com.tw/apiExhibitors/Country`)
          .then((response) => {
            const commonCountryCodes = [
              "TW",
              "CN",
              "JP",
              "KR",
              "US",
              "HK",
              "SG",
              "MY",
            ];
            const allCountries = response.data.Data;

            vm.CountryListCommon = allCountries.filter((country) =>
              commonCountryCodes.includes(country.Country_Code),
            );

            vm.CountryListOther = allCountries.filter(
              (country) => !commonCountryCodes.includes(country.Country_Code),
            );
          })
          .catch((error) => {
            console.error("Failed to load country list:", error);
          });

        axios
          .get(
            `https://www.chanchao.com.tw/apiExhibitors/DirectoryOrg/${vm.RegNo}`,
          )
          .then((response) => {
            if (response.data.Code == 200) {
              vm.DirectoryOrgList = response.data.Data;
              vm.DirectoryOrgTotal = response.data.datatotal;
            } else {
              vm.DirectoryOrgTotal = 0;
            }
          });
      });

    $(document).ready(function () {
      $(".HasDirectory").addClass("hide");
    });
  },
};
</script>

<style lang="scss">
.grayBG {
  background: #f0f4f5;
  color: #333;
  padding: 5px 10px;
  display: inline-block;
  word-break: break-all;
  font-size: 14px;
}

.hide {
  display: none;
}

.show {
  display: block;
}

.modal-body {
  overflow-y: scroll;
  max-height: 70vh;
}

.modal-header {
  background: #f3f3f3;
}

.text-info {
  color: #3c4b9f !important;
}
</style>
